import { jsx as t, jsxs as c, Fragment as m } from "react/jsx-runtime";
import { forwardRef as _ } from "react";
import { B as l } from "./BaseButton-Bhxc5Zyj.mjs";
const u = _(
  ({ children: n, buttonType: r, postfix: a, icon: s, arrow: o, iconClass: e = "", ...d }, i) => /* @__PURE__ */ t(l, { buttonType: r, ref: i, ...d, children: /* @__PURE__ */ c(m, { children: [
    s && /* @__PURE__ */ t("span", { "data-testid": "rds-button__icon", className: `rds-button__icon ${e}`, children: /* @__PURE__ */ t(s, {}) }),
    o && /* @__PURE__ */ t("span", { "data-testid": "rds-button__arrow", className: `rds-button__arrow ${e}`, children: /* @__PURE__ */ t(o, {}) }),
    n,
    !!a && r !== "rds-icon-button" && /* @__PURE__ */ t("span", { className: "rds-button__postfix", children: a })
  ] }) })
);
u.displayName = "BaseDecoratedButton";
export {
  u as B
};
